import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

// eslint-disable-next-line import/prefer-default-export
export const sendFieldToNufiValidation = serviceBase({
  request: ({ field, body }) =>
    axiosClient.post(`/nufi-validation-score/${field}`, { ...body }, { timeout: 300000 })
});
